jQuery(document).ready(function(){
  jQuery('.age-range-slider').on("change input", function() {    
    var classname = jQuery(this).val();    
    jQuery(".sba-main-img").removeClass("active");    
    jQuery(".sba-navigation-title li").removeClass("active");    
    jQuery(".sba-main-img.sba-count-" + classname).addClass("active");
    jQuery(".sba-navigation-title li.sba-count-" + classname).addClass("active");
    var link = jQuery(".sba-navigation-title li.active").attr("link");
    jQuery(".sba-container a").attr("href", link);
  });
});

jQuery(document).ready(function(){
  jQuery(".hps-navigation-title li").click(function(){
    jQuery(".hps-navigation-title li").removeClass("active");
    var classname = jQuery(this).attr("class");
    jQuery(this).addClass("active");
    jQuery(".hps-product-container").removeClass("active");
    jQuery(".hps-product-container." + classname).addClass("active");    
  });
});

jQuery(document).ready(function(){
  jQuery('.ts-inner').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });
});

jQuery(document).ready(function(){
  jQuery('.hbs-container').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    autoplay: true,
  });
});

jQuery(document).ready(function(){
  jQuery('.product-photo-thumbs').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
  ]
  });
});

jQuery(document).ready(function(){
  jQuery(".ask-a-question").click(function(){
    jQuery(".ask-a-question-modal-container").fadeIn();
  });
  jQuery(".ask-a-question-modal-close-overlay").click(function(){
    jQuery(".ask-a-question-modal-container").fadeOut();
  });
  jQuery(".ask-a-question-modal-close").click(function(){
    jQuery(".ask-a-question-modal-container").fadeOut();
  });
});

jQuery(document).ready(function(){
  jQuery(".product-share").click(function(){
    jQuery(".product-share-modal-container").fadeIn();
  });
  jQuery(".product-share-modal-close-overlay").click(function(){
    jQuery(".product-share-modal-container").fadeOut();
  });
  jQuery(".product-share-modal-close").click(function(){
    jQuery(".product-share-modal-container").fadeOut();
  });
});

jQuery(document).ready(function(){
  jQuery(".tab-1-desc").click(function(){
    jQuery(this).toggleClass("active");
    jQuery('.product-tab-description').toggleClass("active");
  });
  jQuery(".tab-2-faq").click(function(){
    jQuery(this).toggleClass("active");
    jQuery('.product-tab-faq').toggleClass("active");
  });
  jQuery(".tab-3-review").click(function(){
    jQuery(this).toggleClass("active");
    jQuery('.product-tab-review').toggleClass("active");
  });
});

function producturl() {
  var copyText = document.getElementById("product_url_copy");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
}

function backClick() {
  if (document.referrer.indexOf(window.location.host) !== -1) {
    history.go(-1); return false;
  }
  else { 
    window.location.href = '/collections/all'; 
  }
}

jQuery(window).scroll(function() {   
  if(jQuery(window).scrollTop() > jQuery(document).height() - jQuery(window).height()){      
    jQuery('.product-sticky-atc').fadeOut();
  }
  else{
    if (jQuery(window).scrollTop() > 300) {
      jQuery('.product-sticky-atc').fadeIn();
    } 
    else { 
      jQuery('.product-sticky-atc').fadeOut();
    }
  }
});

jQuery(window).scroll(function() { 
  if (jQuery(window).width() < 769) {
     var headerheight = jQuery("klug-announcement-bar").height();      
  }
  else {
     var headerheight = jQuery("header").height();
  }
  if (jQuery(window).scrollTop() > headerheight) {    
    jQuery('#shopify-section-header').addClass("header-sticky");
  } 
  else { 
    jQuery('#shopify-section-header').removeClass("header-sticky");
  }
});